import type { CoreHousehold, SampleHousehold } from '../types/financial';
import { deriveHousehold } from './deriveHousehold';

/**
 * Load bundled sample data. Kept in a separate file from `sampleHousehold.json`
 * so Metro/webpack don't resolve `../data/sampleHousehold` to the JSON file
 * (which has no named exports).
 *
 * Fixture is lean core only; UI consumers still receive a derived view.
 */
export const sampleHouseholdCore: CoreHousehold = require('./sampleHousehold.json');

export const sampleHousehold: SampleHousehold = deriveHousehold(sampleHouseholdCore);

export default sampleHousehold;
